import type { PriceTagMarker } from "./PriceTagMap";

/**
 * The order price pins are drawn in, bottom first — the last one lies on top.
 *
 * Rooms in one house share one coordinate, so their pins lie exactly on top
 * of each other and only the top one can be read. Before a room is chosen
 * that is the LOWEST price ("ab" reading; PO, 2026-10-19 — it used to be the
 * highest, by accident of list order). A chosen room lies above all others,
 * so its own price shows. A pin without a price ("Preis auf Anfrage") lies
 * below every priced one.
 */
export const stackOrder = (markers: PriceTagMarker[]): PriceTagMarker[] => {
    const rank = (marker: PriceTagMarker): number =>
        typeof marker.price === "number" && Number.isFinite(marker.price) && marker.price > 0
            ? -marker.price
            : Number.NEGATIVE_INFINITY;
    return [...markers].sort((a, b) => {
        if (!!a.isSelected !== !!b.isSelected) return a.isSelected ? 1 : -1;
        return rank(a) - rank(b) || 0;
    });
};
